import { DatePipe } from '@angular/common';
import { noUndefined } from '@angular/compiler/src/util';
import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { async } from '@angular/core/testing';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { mobiscroll, MbscDatetimeOptions, MbscFormOptions } from '@mobiscroll/angular';

import * as alertifyjs from 'alertifyjs';
import { SocketioService } from 'src/app/services/socket/socketio.service';

import Swal from 'sweetalert2';
import { AuthService } from 'src/app/services/auth/auth.service';
import { saveAs } from 'file-saver';

mobiscroll.settings = {
  lang: 'es',
  theme: 'ios',
  themeVariant: 'light',
};


const now = new Date();

//const week = [ new Date(now.getFullYear(),0, 1),now];
let week = [new Date(), new Date()];

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css'],
  providers: [DatePipe]

})



export class PaymentsComponent implements OnInit {

  queryParams: any;
  person: any;
  section_transactions: any = [];
  transaction: any = {};
  section_transaction: any;
  loading_person = false;
  loading = false;

  buro_response: any;
  buro: any;
  buro_score: any;
  activatePsico: any;
  showActivatePsico: any;

  loading_buro = false;
  psicometrico: any;
  psicometrico_response: any;
  psicometrico_array: any = [];
  status_approved: any;
  type_approved: any;
  clientQuota: any;
  invoiceCredits: any = [];
  resp_paymentsCredits: any = [];
  installments: any = [];
  view = 1;
  invoiceSelected: any;
  installMentSelected: any;
  payment: any;
  loadcon: any;
  loadcon2: any;

  filter: any = {
    type: 'p',
    account: '',
    sub_status: 'NA'
  }

  accountPayment_load: any;
  accounts: any;
  selectedAccountPayment: any = null;
  loadingAccountPaymentDetails: boolean = false;

  // Propiedades para ordenamiento por fecha de creación
  sortField: string = 'created_at';
  sortOrder: 'asc' | 'desc' = 'asc';

  autopago: any = [{ key: "BA", name: "AUTO: BANCAAMIGA" }, { key: "MERCHANT", name: "AUTO: MEGASOFT" }, { key: "MC", name: "AUTO: MERCANTIL" }, { key: "BDV", name: "AUTO: BANCO DE VENEZUELA" }, { key: "AUTO-DETECT", name: "Auto detectado" }];

  page = 1; // Current page number
  limit = 100; // Number of documents per page

  range: Array<Date> = week;
  date: Array<Date> = [];
  nonForm: Array<Date> = [];
  external = week;
  d1: any;
  d2: any;
  subStatus: any = {};
  submit_disabled_changeSubStatus: any;
  list_payment_sub_status: any;

  // === FILTRO MÚLTIPLE DE PRODUCTOS - Propiedades ===
  productArray: any[] = [];
  selectedProducts: string[] = ['CREDIT']; // Productos seleccionados (estado final)
  showDropdown: boolean = false; // Visibilidad del dropdown
  tempSelectedProducts: string[] = ['CREDIT']; // Productos temporales (antes de aplicar)

  // === SISTEMA DE ESTADOS PROFESIONAL ===
  filterStates = {
    isLoadingProducts: false,    // Cargando lista de productos
    isApplyingFilter: false,     // Aplicando filtro seleccionado
    isLoadingResults: false,     // Cargando resultados de pagos
    hasError: false,             // Estado de error
    errorMessage: '',            // Mensaje de error específico
    isInitialized: false         // Si el filtro ya se inicializó
  };

  // Estados de animación
  dropdownAnimation = {
    isOpening: false,
    isClosing: false
  };

  // Legacy property for compatibility
  typeProduct: string = 'CREDIT';

  // ================================================================================
  // PROPIEDADES FLUJO SIMPLIFICADO BDV - Workflow Verificación
  // ================================================================================

  simplifiedFlow = {
    enabled: false,
    step: 'phone', // 'phone' → 'amount' → 'verify' → ['reference'] → 'confirm' → 'upload' → 'register'
    loading: false,
    data: {
      date: null as Date | null,
      phone: null as string | null,
      amount: null as string | null,
      reference: null as string | null,
      paymentToken: null as string | null,
      file: null as any
    },
    verification: {
      matches: null as 'none' | 'unique' | 'multiple' | null,
      paymentData: null as any,
      requiresReference: false
    },
    errors: {
      date: '',
      phone: '',
      amount: '',
      reference: '',
      file: ''
    }
  };


  dateSetting3: MbscDatetimeOptions = {
    lang: 'es',
    theme: 'ios',
    themeVariant: 'light',
    max: now,
    responsive: {
      small: {
        controls: ['calendar'],
        display: 'center'
      },
      medium: {
        display: 'bubble',
      }
    }

  };

  birthday = new Date();
  date_base: any = new Date;
  date_base_string: any;
  banks: any;


  mobileSettings: MbscDatetimeOptions = {
    display: 'bottom',
    themeVariant: 'dark',
  };


  desktopSettings: MbscDatetimeOptions = {
    display: 'bubble',
    touchUi: false
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    public socketService: SocketioService,
    public _auth: AuthService,
    private elementRef: ElementRef,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {

    this.getBanks();

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');

    // Inicializar variables para evitar errores en template
    this.resp_paymentsCredits = [];
    this.accounts = [];
    this.list_payment_sub_status = [];
    this.productArray = [];
    this.banks = {};

    this.loading_person = true;

    // Cargar datos iniciales de forma secuencial para asegurar dependencias
    this.initializeData();

  }

  async initializeData() {
    try {
      // Primero cargar los productos para asegurar que typeProduct sea válido
      await this.consultAllProductsInvoices();

      // 💎 Actualizar el término de búsqueda con el filtro por defecto (CREDIT)
      this.updateSearchTermFromSelection();

      // Verificar si el typeProduct actual es válido, si no, usar el primero disponible
      if (this.productArray.length > 0) {
        const validProduct = this.productArray.find(p => p?.params?.code === this.typeProduct);
        if (!validProduct) {
          this.typeProduct = this.productArray[0]?.params?.code || 'CREDIT';
        }
      } else {
        // Si no hay productos en la BD, usar valores por defecto
        this.productArray = [
          { params: { code: 'CREDIT' } },
          { params: { code: 'RECARGAS' } }
        ];
        this.typeProduct = 'CREDIT';
      }

      // Ahora cargar los pagos con el typeProduct correcto
      await this.getPayments();
      await this.getAccountPayment();
      await this.getpayment_sub_status();

    } catch (error) {
      console.error('Error en initializeData:', error);
    }
  }

  getPayments = async (isPagination = false) => {
    try {
      this.loading_person = true;
      const resp = await this.listPaymentsCredits();
      const newResults = resp?.res || [];

      if (isPagination) {
        // En paginación, agregar nuevos resultados a los existentes
        // Solo si hay nuevos resultados, para evitar borrar cuando no hay más datos
        if (newResults.length > 0) {
          this.resp_paymentsCredits = [...this.resp_paymentsCredits, ...newResults];
        }
        // Si no hay nuevos resultados en paginación, no modificar la lista existente
      } else {
        // En búsqueda inicial o cambio de filtros, reemplazar completamente
        this.resp_paymentsCredits = newResults;
      }

      // Verificar que resp_paymentsCredits sea un array antes de iterar
      if (Array.isArray(newResults)) {
        newResults.forEach((elem: any) => {
          if (elem?.payment?.code) {
            this.subStatus[elem.payment.code] = elem.payment.payment_sub_status?.code || 'NA';
          }
        });
      }
    } catch (error) {
      console.error('Error in getPayments:', error);
      if (!isPagination) {
        this.resp_paymentsCredits = [];
      }
    }
    this.loading_person = false;
  }

  concilidarPago = async (payment: any) => {
    let action = 'Conciliar';
    let confirm = false;

    // verifico que el pago no este repetido, sino, emitimos alerta
    if (payment?.payments_similar && payment.payments_similar.length > 0) {
      Swal.fire({
        title: `Ya existe un pago con la misma referencia, cuenta destino y monto`,
        text: "¡No es posible conciliar!",
        icon: 'warning',

      }).then((result) => {
        if (result.isConfirmed) {
          confirm = false; // no queremos que si lo concilie
        }
      });
    } else {
      confirm = true;
    }

    if (confirm) {

      Swal.fire({
        title: `¿Deseas ${action} este pago?`,
        text: "¡No podrás revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: `Si, ${action}!`
      }).then((result) => {
        if (result.isConfirmed) {

          this.concilidarPagoQuestion(payment.code);

        }
      });
    }

  }


  cancelPayment = async (payment: any) => {

    let action = 'Anular'

    Swal.fire({
      title: "¿Deseas Anular este pago?",
      text: "¡No podrás revertir esto!",
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      input: "select",
      inputOptions: {
        
        'No se encuentra en banco': 'No se encuentra en banco',
        'Pago duplicado': 'Pago duplicado',
        'Txs verificada por Merchant': 'Txs verificada por Merchant',
        'Txs verificada manualmente': 'Txs verificada manualmente',

      },
      inputPlaceholder: 'Selecciona una razón',
      showCancelButton: true,
      confirmButtonText: `Si, ${action}!`,
      showLoaderOnConfirm: true,
      preConfirm: async (reason) => {
        try {
          if (!reason) {
            return Swal.showValidationMessage(`Debe seleccionar una razón de anulación`);
          }
        } catch (error) {
          Swal.showValidationMessage(`Request failed: ${error}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        this.cancelPaymentQuestion(payment, result.value);
      }
    });
  }



  concilidarPagoQuestion = async (payment: any) => {
    this.loadcon = true;
    try {
      const resp = await this._user.reconciledPayment({ code_payment: payment });
      const resp_paymentsCredits = await this.listPaymentsCredits();
      this.resp_paymentsCredits = resp_paymentsCredits?.res;

      if (this.subStatus[payment] == 'REVISION') {
        this.changeSubStatus(payment, 'NA')

      }

      if (resp?.res) {


        this.getPayments();


      }

      this.loadcon = false;

    } catch (error) {
      console.error(error);

      this.loadcon = false;
    }

    this.loading_person = false;


  }


  cancelPaymentQuestion = async (payment: any, msg = '') => {

    this.loadcon2 = true;
    try {

      const resp = await this._user.cancelPayment({ code_payment: payment, description: msg });

      if (this.subStatus[payment] == 'REVISION') {
        this.changeSubStatus(payment, 'NA')

      }

      const resp_paymentsCredits = await this.listPaymentsCredits();


      this.resp_paymentsCredits = resp_paymentsCredits?.res;



      if (resp?.res) {
        this.getPayments();

        alertifyjs.success(`Pago anulado codigo ${payment}`);

      }
      this.loadcon2 = false;

    } catch (error) {
      console.error(error);

      this.loadcon2 = false;
    }


    this.loading_person = false;


  }


  async listPaymentsCredits(typeProduct = this.typeProduct) {
    try {
      this.limit = 200; // Number of documents per page

      let body = {
        ...this.filter,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        arr_typeProduct: this.selectedProducts // Usar array de productos seleccionados
      };

      // 🔍 DEBUG: Ver qué productos se están enviando
      console.log('🔍 DEBUG listPaymentsCredits - selectedProducts:', this.selectedProducts);
      console.log('🔍 DEBUG listPaymentsCredits - body.arr_typeProduct:', body.arr_typeProduct);
      console.log('🔍 DEBUG listPaymentsCredits - body completo:', body);

      if (body.type == 'p') {
        this.limit = 200; // Number of documents per page
      }

      let request = {
        page: this.page,
        limit: this.limit,
        init: this.d1,
        end: this.d2
      };

      const resp = await this._user.listPaymentsCredits(body, request);

      const result = {
        res: resp?.res || [],
        total: resp?.total || 0
      };

      return result;

    } catch (error) {
      console.error('Error in listPaymentsCredits:', error);
      return {
        res: [],
        total: 0
      };
    }
  }




  getIdentity(item: any) {

    if (!(item?.identitys?.length > 0))
      return "";

    return `${item?.identitys[0]?.type_identity?.name} ${item?.identitys[0]?.code_identity?.name}-${item?.identitys[0]?.identity}`;

  }


  getContact(item: any) {

    if (!(item?.constacts?.length > 0))
      return "";

    return `${item?.constacts[0]?.contact}`;


  }

  getEmailContact(item: any) {
    if (!(item?.constacts?.length > 0) || !item?.constacts[1]) return '';

    return `${item?.constacts[1]?.contact}`;
  }


  sanitize(url: string) {
    //return url;
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }


  // 🖼️ MODAL DE VISUALIZACIÓN DE ADJUNTOS
  selectedFileUrl = '';
  selectedFileType = '';
  selectedFileName = '';
  selectedFileExtension = '';

  /**
   * Abre modal para visualizar archivos adjuntos o descarga PDFs
   * @param fileData - Objeto file con {url, type_file, base_name} o string (URL)
   * @param modalContent - Template del modal
   */
  async redirectIMG(fileData: any, modalContent?: any): Promise<void> {
    console.log('🔍 DEBUG redirectIMG - fileData recibido:', fileData);
    console.log('🔍 DEBUG redirectIMG - tipo de fileData:', typeof fileData);
    console.log('🔍 DEBUG redirectIMG - fileData.url:', fileData?.url);
    console.log('🔍 DEBUG redirectIMG - fileData.type_file:', fileData?.type_file);
    console.log('🔍 DEBUG redirectIMG - fileData.base_name:', fileData?.base_name);
    
    // Extraer datos del archivo
    let url: string;
    let fileType: string;
    let fileName: string;
    
    if (typeof fileData === 'string') {
      // Compatibilidad: si solo pasan URL
      console.log('⚠️ fileData es string, usando compatibilidad');
      url = fileData;
      fileType = url.toLowerCase().includes('.pdf') ? 'pdf' : 'image';
      fileName = `comprobante_${Date.now()}`;
    } else if (fileData && fileData.url) {
      // Formato correcto: objeto file del backend
      console.log('✅ fileData es objeto con url');
      url = fileData.url;
      fileType = fileData.type_file || 'pdf';
      fileName = fileData.base_name || `comprobante_${Date.now()}`;
    } else {
      console.error('❌ Formato de archivo inválido:', fileData);
      return;
    }

    if (!url) return;

    // Guardar datos para uso posterior
    this.selectedFileUrl = url;
    this.selectedFileName = fileName;
    this.selectedFileExtension = fileType;

    // Detectar si es PDF
    const isPdf = fileType.toLowerCase() === 'pdf';

    if (isPdf) {
      // PDFs: descargar directamente usando el endpoint del backend
      const fileNameWithExt = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
      
      const blob = await this._user.downloadFile(url, fileType);
      
      if (blob) {
        saveAs(blob, fileNameWithExt);
      } else {
        alertifyjs.error('Error al descargar el archivo');
        window.open(url, '_blank');
      }
    } else {
      // Imágenes: mostrar en modal
      this.selectedFileType = 'image';
      
      if (modalContent) {
        this.modalService.open(modalContent, {
          size: 'xl',
          centered: true,
          backdrop: 'static'
        });
      }
    }
  }

  /**
   * Maneja el error de carga de imagen
   * Si falla, descarga el archivo usando el servicio
   */
  async onImageError(): Promise<void> {
    console.log('Error cargando imagen, descargando archivo...');
    this.closeFileModal();
    
    const fileName = this.selectedFileName || `comprobante_${Date.now()}`;
    const fileExtension = this.selectedFileExtension || 'pdf';
    const fileNameWithExt = fileName.endsWith(`.${fileExtension}`) ? fileName : `${fileName}.${fileExtension}`;
    
    const blob = await this._user.downloadFile(this.selectedFileUrl, fileExtension);
    
    if (blob) {
      saveAs(blob, fileNameWithExt);
    } else {
      alertifyjs.error('Error al descargar el archivo');
      window.open(this.selectedFileUrl, '_blank');
    }
  }

  /**
   * Descarga el archivo actual del modal
   */
  async downloadCurrentFile(): Promise<void> {
    const fileName = this.selectedFileName || `comprobante_${Date.now()}`;
    const fileExtension = this.selectedFileExtension || 'jpg';
    const fileNameWithExt = fileName.endsWith(`.${fileExtension}`) ? fileName : `${fileName}.${fileExtension}`;
    
    const blob = await this._user.downloadFile(this.selectedFileUrl, fileExtension);
    
    if (blob) {
      saveAs(blob, fileNameWithExt);
    } else {
      alertifyjs.error('Error al descargar el archivo');
    }
  }

  /**
   * Cierra el modal de visualización
   */
  closeFileModal(): void {
    this.selectedFileUrl = '';
    this.selectedFileType = '';
    this.selectedFileName = '';
    this.selectedFileExtension = '';
    this.modalService.dismissAll();
  }

  setFilter() {

    this.page = 1;
    this.resp_paymentsCredits = [];

    // Obtener detalles del account payment seleccionado
    if (this.filter.account) {
      this.getAccountPaymentDetails(this.filter.account);
    } else {
      this.selectedAccountPayment = null;
    }

    this.getPayments();

  }

  getAccountPayment = async () => {

    this.accountPayment_load = true;

    try {

      let resp = await this._user.account_payment();
      this.accounts = resp?.res || [];

      //necesito ordenar accounts por item?.bank?.name
      if (Array.isArray(this.accounts)) {
        this.accounts.sort((a: any, b: any) => {
          const nameA = a?.bank?.name?.toLowerCase() || '';
          const nameB = b?.bank?.name?.toLowerCase() || '';
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
      }

    } catch (error) {
      console.log('Error in getAccountPayment:', error);
      this.accounts = [];
    }

    this.accountPayment_load = false;

  }

  getAccountPaymentDetails = async (accountId: string) => {
    if (!accountId) {
      this.selectedAccountPayment = null;
      return;
    }

    this.loadingAccountPaymentDetails = true;

    try {
      // Buscar el account payment en la lista existente
      const accountFound = this.accounts?.find((account: any) => account.code === accountId);

      if (accountFound) {
        this.selectedAccountPayment = accountFound;
      } else {
        // Si no se encuentra en la lista, hacer una nueva consulta
        const resp = await this._user.account_payment();
        const allAccounts = resp?.res || [];
        this.selectedAccountPayment = allAccounts.find((account: any) => account.code === accountId) || null;
      }

      // ================================================================================
      // DETECCIÓN FLUJO SIMPLIFICADO BDV
      // ================================================================================
      await this.checkBDVWorkflow();

    } catch (error) {
      console.error('Error al obtener detalles del account payment:', error);
      this.selectedAccountPayment = null;
    }

    this.loadingAccountPaymentDetails = false;
  }

  nextRows = () => {

    this.page = this.page + 1;
    this.getPayments(true); // Indicar que es paginación

  }

  birthdaySet() {

    this.resp_paymentsCredits = [];
    this.page = 1;

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    this.getPayments();

  }

  /**
   * Cambiar orden de clasificación por fecha
   */
  changeSortOrder(order: 'asc' | 'desc') {
    if (this.sortOrder !== order) {
      this.sortOrder = order;
      this.applySortFilter();
    }
  }

  /**
   * Aplicar filtro de ordenamiento
   */
  applySortFilter() {
    this.resp_paymentsCredits = [];
    this.page = 1;
    this.getPayments();
  }

  /**
   * Obtener el ícono del ordenamiento actual
   */
  getSortIcon(): string {
    return this.sortOrder === 'asc' ? '↑' : '↓';
  }

  /**
   * Obtener el texto del ordenamiento actual
   */
  getSortText(): string {
    return this.sortOrder === 'asc' ? 'Más Antiguo' : 'Más Reciente';
  }

  findAutopago = (acron: string) => {
    console.log(acron);
    if (acron === "BA" || acron === "MC" || acron === "BDV" || acron === "AUTO-DETECT") {
      let autopago = this.autopago.find((ele: any) => ele.key === acron);
      if (autopago) {
        return autopago.name;
      } else {
        return null;
      }
    } else {
      return acron
    }
  }


  getBanks = async () => {

    try {

      let resp = await this._user.getBanks();

      // Convertir el array de bancos en un objeto para acceso rápido
      this.banks = {};
      if (resp?.res && Array.isArray(resp.res)) {
        resp.res.forEach((bank: any) => {
          if (bank?.code && bank?.name) {
            this.banks[bank.code] = bank.name;
          }
        });
      }

    } catch (error) {
      console.log('Error in getBanks:', error);
      this.banks = {};
    }

  }


  getBanksServices = async () => {
    return await this._user.getBanks({});
  };


  setPayment(data: any) {


    let action = 'Editar'

    Swal.fire({
      title: `¿Deseas ${action} este pago?`,
      text: "¡No podrás revertir esto!",
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      input: "select",
      inputOptions: {
        'Banco Receptor errado': 'Banco Receptor errado',
        'Banco Emisor errado': 'Banco Emisor errado',
        'Número de referencia errado': 'Número de referencia errado',
        'Fecha de Pago errada': 'Fecha de Pago errada',
        'Monto errado': 'Monto errado',
        'Comprobante de pago errado': 'Comprobante de pago errado'
      },
      inputPlaceholder: 'Selecciona una razón',
      showCancelButton: true,
      confirmButtonText: `Si, ${action}!`,
      showLoaderOnConfirm: true,
      preConfirm: async (reason) => {
        try {
          if (!reason) {
            return Swal.showValidationMessage(`Debe seleccionar una razón de Edición`);
          }
        } catch (error) {
          Swal.showValidationMessage(`Request failed: ${error}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        data.description_edit = result?.value;
        localStorage.setItem('pe', JSON.stringify(data));
        this.router.navigate([`/console/post`], {});


      }
    });




  }


  changeSubStatus = async (code: any, code_sub: any) => {
    this.submit_disabled_changeSubStatus = true;


    let query = {
      code_payment: code,
      code_payment_sub_status: code_sub
    };

    await this._user.payment_sub_statusPost(query);
    this.subStatus[code] = code_sub;
    alertifyjs.success('Cambio exitoso');
    this.submit_disabled_changeSubStatus = false;




  }


  getpayment_sub_status = async () => {

    try {

      let resp = await this._user.payment_sub_status();
      this.list_payment_sub_status = resp?.resp || [];
      debugger

    } catch (error) {
      console.log('Error in getpayment_sub_status:', error);
      this.list_payment_sub_status = [];
    }

  }

  payment_sub_status = async () => {
    try {
      return this._user.payment_sub_status({});

    } catch (error) {
      console.error(error);


    }
  }


  paymentRollback = async (payment: any) => {

    let action = 'Revertir'

    Swal.fire({
      title: `¿Deseas ${action} este pago?`,
      text: "¡No podrás revertir esto!",
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      input: "select",
      inputOptions: {

        'No se encontro en banco': 'No se encontro en banco'

      },
      inputPlaceholder: 'Selecciona una razón',
      showCancelButton: true,
      confirmButtonText: `Si, ${action}!`,
      showLoaderOnConfirm: true,
      preConfirm: async (reason) => {
        try {
          if (!reason) {
            return Swal.showValidationMessage(`Debe seleccionar una razón`);
          }
        } catch (error) {
          Swal.showValidationMessage(`Request failed: ${error}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {

        this.servicePaymentRollback(payment, result.value);

      }
    });
  }


  servicePaymentRollback = async (payment: any, msg = '') => {

    this.loadcon2 = true;

    try {

      const resp = await this._user.paymentRollback({ code_payment: payment, description: msg });

      const resp_paymentsCredits = await this.listPaymentsCredits();
      this.resp_paymentsCredits = resp_paymentsCredits?.res;



      if (resp?.res) {
        this.getPayments();

        alertifyjs.success(`Pago devuelto `);

      }
      this.loadcon2 = false;

    } catch (error) {
      alertifyjs.error('Error al devolver pago estatus');

      console.error(error);

      this.loadcon2 = false;
    }


    this.loading_person = false;


  }


  async consultAllProductsInvoices() {
    try {
      this.filterStates.isLoadingProducts = true;
      this.filterStates.hasError = false;

      console.log('🔍 DEBUG: Iniciando carga de productos...');
      let consultProducts = await this._user.getTypesProductsInvoices();
      console.log('🔍 DEBUG: Respuesta de getTypesProductsInvoices:', consultProducts);

      // Verificar que la respuesta sea válida
      if (consultProducts && consultProducts.resp && Array.isArray(consultProducts.resp)) {
        this.productArray = consultProducts.resp;
        this.filteredProductArray = [...this.productArray]; // Inicializar array filtrado
        this.tempSelectedProducts = [...this.selectedProducts]; // Inicializar temp
        this.filterStates.isInitialized = true;
        console.log('✅ DEBUG: Productos cargados correctamente:', this.productArray.length, 'productos');
        console.log('✅ DEBUG: productArray:', this.productArray);
        console.log('✅ DEBUG: filteredProductArray:', this.filteredProductArray);
      } else {
        console.warn('⚠️ DEBUG: Respuesta inválida, usando fallback');
        this.productArray = [{ params: { code: 'CREDIT' } }]; // Fallback básico
        this.filteredProductArray = [...this.productArray];
        this.tempSelectedProducts = ['CREDIT'];
        this.filterStates.isInitialized = true;
      }

    } catch (error) {
      console.error('❌ ERROR: Error al cargar productos:', error);
      // No mostrar error al usuario, solo usar fallback
      this.productArray = [{ params: { code: 'CREDIT' } }]; // Fallback básico
      this.filteredProductArray = [...this.productArray];
      this.tempSelectedProducts = ['CREDIT'];
      this.selectedProducts = ['CREDIT'];
      this.filterStates.isInitialized = true;
    } finally {
      this.filterStates.isLoadingProducts = false;
    }
  }

  // === MANEJO PROFESIONAL DEL DROPDOWN ===
  async toggleDropdown() {
    if (this.showDropdown) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  async openDropdown() {
    if (this.filterStates.isLoadingProducts) return;

    // Sincronizar tempSelectedProducts con selectedProducts al abrir
    this.tempSelectedProducts = [...this.selectedProducts];
    console.log('🔄 Abriendo dropdown - tempSelectedProducts:', this.tempSelectedProducts);
    console.log('🔄 Abriendo dropdown - selectedProducts:', this.selectedProducts);

    this.dropdownAnimation.isOpening = true;

    // Inicializar array filtrado si no hay búsqueda
    if (!this.productSearchTerm || this.productSearchTerm.trim() === '') {
      this.filteredProductArray = [...this.productArray];
    }

    // Pequeño delay para la animación
    setTimeout(() => {
      this.showDropdown = true;
      this.dropdownAnimation.isOpening = false;
    }, 50);
  }

  async closeDropdown() {
    this.dropdownAnimation.isClosing = true;

    setTimeout(() => {
      this.showDropdown = false;
      this.dropdownAnimation.isClosing = false;
      // Restaurar selección temporal si no se aplicó
      this.tempSelectedProducts = [...this.selectedProducts];
    }, 150);
  }

  // Detectar clics fuera del componente para cerrar el dropdown
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.showDropdown) {
      const productSearchContainer = this.elementRef.nativeElement.querySelector('.product-search-input');
      if (productSearchContainer) {
        const clickedInside = productSearchContainer.contains(event.target as Node);
        if (!clickedInside) {
          this.closeDropdown();
        }
      }
    }
  }

  // === MANEJO INTELIGENTE DE SELECCIÓN (MÚLTIPLE - mantener checkboxes funcionales) ===
  onProductSelectionChange(productCode: string, isChecked: boolean) {
    try {
      if (isChecked) {
        // Agregar producto si no está ya seleccionado
        if (!this.tempSelectedProducts.includes(productCode)) {
          this.tempSelectedProducts.push(productCode);
        }
      } else {
        // Remover producto de la selección
        this.tempSelectedProducts = this.tempSelectedProducts.filter(code => code !== productCode);
      }

      // Si no hay productos seleccionados, mantener CREDIT por defecto
      if (this.tempSelectedProducts.length === 0) {
        this.tempSelectedProducts = ['CREDIT'];
      }

      // Actualizar el término de búsqueda inmediatamente para reflejar la selección
      this.updateSearchTermFromTempSelection();

      console.log('🔄 DEBUG: Productos temporales seleccionados:', this.tempSelectedProducts);
    } catch (error) {
      console.error('❌ ERROR en selección:', error);
    }
  }

  // Actualizar el término de búsqueda basado en la selección temporal
  updateSearchTermFromTempSelection() {
    if (this.tempSelectedProducts.length === 0) {
      this.productSearchTerm = '';
    } else if (this.tempSelectedProducts.length === 1) {
      this.productSearchTerm = this.tempSelectedProducts[0];
    } else if (this.tempSelectedProducts.length === 2) {
      this.productSearchTerm = `${this.tempSelectedProducts[0]} y ${this.tempSelectedProducts[1]}`;
    } else {
      this.productSearchTerm = `${this.tempSelectedProducts.length} productos seleccionados`;
    }
  }

  // === APLICACIÓN PROFESIONAL DE FILTROS ===
  async applyFilters() {
    try {
      this.filterStates.isApplyingFilter = true;
      this.filterStates.isLoadingResults = true;
      this.filterStates.hasError = false;

      // Confirmar selección
      this.selectedProducts = [...this.tempSelectedProducts];

      // Actualizar la barra de búsqueda con el texto de los productos seleccionados
      this.updateSearchTermFromSelection();

      // Animación de cierre suave
      await this.closeDropdown();

      // Resetear paginación y ejecutar consulta
      this.page = 1;
      this.resp_paymentsCredits = [];
      await this.getPayments();

    } catch (error) {
      console.error('❌ ERROR al aplicar filtros:', error);
      // Solo mostrar error si es crítico
      if (!this.resp_paymentsCredits || this.resp_paymentsCredits.length === 0) {
        this.filterStates.hasError = true;
        this.filterStates.errorMessage = 'Error al cargar pagos';
      }
    } finally {
      this.filterStates.isApplyingFilter = false;
      this.filterStates.isLoadingResults = false;
    }
  }

  // === FUNCIONES DE UTILIDAD MEJORADAS ===
  isProductSelected(productCode: string): boolean {
    return this.tempSelectedProducts.includes(productCode);
  }

  getSelectedProductsText(): string {
    const count = this.selectedProducts.length;

    if (count === 0) {
      return 'Seleccionar productos...';
    }
    if (count === 1) {
      return this.selectedProducts[0];
    }
    if (count === 2) {
      return `${this.selectedProducts[0]} y ${this.selectedProducts[1]}`;
    }
    return `${count} productos seleccionados`;
  }

  async clearAllFilters() {
    this.tempSelectedProducts = ['CREDIT'];
    this.selectedProducts = ['CREDIT'];

    try {
      this.filterStates.isLoadingResults = true;
      this.page = 1;
      this.resp_paymentsCredits = [];
      await this.getPayments();
    } catch (error) {
      console.error('❌ ERROR al limpiar filtros:', error);
    } finally {
      this.filterStates.isLoadingResults = false;
    }
  }

  // === FUNCIÓN DE RETRY PARA ERRORES ===
  async retryOperation() {
    this.filterStates.hasError = false;
    this.filterStates.errorMessage = '';

    try {
      if (!this.filterStates.isInitialized) {
        await this.consultAllProductsInvoices();
      } else {
        await this.applyFilters();
      }
    } catch (error) {
      console.error('❌ ERROR en retry:', error);
      this.filterStates.hasError = false;
      this.filterStates.errorMessage = '';
    }
  }

  // === FUNCIONES DE OPTIMIZACIÓN ===
  trackByProductCode(index: number, item: any): string {
    return item?.params?.code || index;
  }

  setCodeTypeProduct(event: any) {
    try {
      const selectedValue = event.target.value;

      // Actualizar filtro con selección única para compatibilidad legacy
      this.selectedProducts = [selectedValue];
      this.tempSelectedProducts = [selectedValue];
      this.typeProduct = selectedValue;

      this.page = 1;
      this.resp_paymentsCredits = [];
      this.getPayments();
    } catch (error) {
      console.error(error);
    }
  }

  // 🤖 MÉTODOS PARA VERIFICACIÓN ASÍNCRONA
  selectedAsyncPayment: any = null;

  // 🏥 MÉTODOS PARA REPORTE DE SEGUROS
  selectedInsuranceReportPayment: any = null;

  /**
   * 📅 Formatear fecha para mostrar en la interfaz asíncrona
   */
  formatAsyncDate(dateString: string): string {
    if (!dateString) return 'N/A';

    try {
      const date = new Date(dateString);
      return date.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return 'Fecha inválida';
    }
  }

  /**
   * 📋 Abrir modal de historial asíncrono
   */
  openAsyncHistoryModal(payment: any) {
    this.selectedAsyncPayment = payment;

    // Intentar múltiples métodos para abrir el modal
    try {
      // Método 1: Bootstrap 5 API
      const modalElement = document.getElementById('asyncHistoryModal');
      if (modalElement) {
        // Verificar si Bootstrap está disponible
        if (typeof (window as any).bootstrap !== 'undefined') {
          const modal = new (window as any).bootstrap.Modal(modalElement);
          modal.show();
          return;
        }

        // Método 2: jQuery Bootstrap (fallback)
        if (typeof (window as any).$ !== 'undefined') {
          (window as any).$('#asyncHistoryModal').modal('show');
          return;
        }

        // Método 3: Atributos HTML directos (fallback)
        modalElement.setAttribute('style', 'display: block');
        modalElement.classList.add('show');
        document.body.classList.add('modal-open');

        // Crear backdrop
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        backdrop.id = 'asyncModalBackdrop';
        document.body.appendChild(backdrop);
      }
    } catch (error) {
      // Silenciar errores en producción
    }
  }

  /**
   * 🚪 Cerrar modal manualmente (si es necesario)
   */
  closeAsyncHistoryModal() {
    try {
      const modalElement = document.getElementById('asyncHistoryModal');
      const backdrop = document.getElementById('asyncModalBackdrop');

      if (modalElement) {
        modalElement.setAttribute('style', 'display: none');
        modalElement.classList.remove('show');
        document.body.classList.remove('modal-open');
      }

      if (backdrop) {
        backdrop.remove();
      }
    } catch (error) {
      // Silenciar errores en producción
    }
  }

  /**
   * 🏥 Abrir modal de historial de reporte de seguros
   */
  openInsuranceReportHistoryModal(payment: any) {
    this.selectedInsuranceReportPayment = payment;

    // Intentar múltiples métodos para abrir el modal
    try {
      // Método 1: Bootstrap 5 API
      const modalElement = document.getElementById('insuranceReportHistoryModal');
      if (modalElement) {
        // Verificar si Bootstrap está disponible
        if (typeof (window as any).bootstrap !== 'undefined') {
          const modal = new (window as any).bootstrap.Modal(modalElement);
          modal.show();
          return;
        }

        // Método 2: jQuery Bootstrap (fallback)
        if (typeof (window as any).$ !== 'undefined') {
          (window as any).$('#insuranceReportHistoryModal').modal('show');
          return;
        }

        // Método 3: Atributos HTML directos (fallback)
        modalElement.setAttribute('style', 'display: block');
        modalElement.classList.add('show');
        document.body.classList.add('modal-open');

        // Crear backdrop
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        backdrop.id = 'insuranceReportModalBackdrop';
        document.body.appendChild(backdrop);
      }
    } catch (error) {
      // Silenciar errores en producción
    }
  }

  /**
   * 🚪 Cerrar modal de historial de reporte de seguros
   */
  closeInsuranceReportHistoryModal() {
    try {
      const modalElement = document.getElementById('insuranceReportHistoryModal');
      const backdrop = document.getElementById('insuranceReportModalBackdrop');

      if (modalElement) {
        modalElement.setAttribute('style', 'display: none');
        modalElement.classList.remove('show');
        document.body.classList.remove('modal-open');
      }

      if (backdrop) {
        backdrop.remove();
      }
    } catch (error) {
      // Silenciar errores en producción
    }
  }

  // ================================================================================
  // MÉTODO REPORTE MANUAL A ASEGURADORA
  // ================================================================================

  retryInsuranceReport(item: any) {
    const paymentCode = item.payment.code;
    const hasReport = item.payment.params?.insurance_report;
    const action = hasReport ? 'reintentar el reporte' : 'reportar el pago';

    Swal.fire({
      title: '¿Confirmar?',
      text: `¿Desea ${action} a la aseguradora para el pago ${paymentCode}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        item.payment._retryingInsurance = true;

        this._user.retryOrCreateInsuranceReport(paymentCode).subscribe(
          (resp: any) => {
            item.payment._retryingInsurance = false;
            if (resp.success) {
              Swal.fire('Éxito', resp.message || 'Pago reportado exitosamente', 'success');
            } else {
              Swal.fire('Atención', resp.message || 'No se pudo reportar el pago', 'warning');
            }
            this.getPayments();
          },
          (error: any) => {
            item.payment._retryingInsurance = false;
            const msg = error?.error?.message || error?.message || 'Error desconocido';
            Swal.fire('Error', `No se pudo ${action}: ${msg}`, 'error');
            this.getPayments();
          }
        );
      }
    });
  }

  // ================================================================================
  // MÉTODOS FLUJO SIMPLIFICADO BDV - Workflow Verificación
  // ================================================================================

  /**
   * Verificar si el account payment seleccionado tiene workflow_verificacion_bdv
   */
  checkBDVWorkflow = async () => {
    console.log('[BDV DEBUG] selectedAccountPayment:', this.selectedAccountPayment);
    console.log('[BDV DEBUG] workflow value:', this.selectedAccountPayment?.workflow);
    console.log('[BDV DEBUG] workflow type:', typeof this.selectedAccountPayment?.workflow);

    if (this.selectedAccountPayment?.workflow === 'workflow_verificacion_bdv') {
      console.log('[BDV] ✅ Activando flujo simplificado para:', this.selectedAccountPayment.name);
      this.simplifiedFlow.enabled = true;
      this.simplifiedFlow.step = 'phone'; // Empezar con teléfono según el documento
      this.resetSimplifiedFlow();

      // Cargar automáticamente el teléfono del usuario con un pequeño delay
      setTimeout(async () => {
        await this.loadUserPhoneForBDV();
      }, 100);
    } else {
      console.log('[BDV] ❌ Flujo tradicional para:', this.selectedAccountPayment?.name || 'Sin selección');
      console.log('[BDV] ❌ Workflow actual:', this.selectedAccountPayment?.workflow || 'undefined');
      this.simplifiedFlow.enabled = false;
    }
  };

  /**
   * Resetear datos del flujo simplificado
   */
  resetSimplifiedFlow = () => {
    this.simplifiedFlow.data = {
      date: null,
      phone: null,
      amount: null,
      reference: null,
      paymentToken: null,
      file: null
    };
    this.simplifiedFlow.verification = {
      matches: null,
      paymentData: null,
      requiresReference: false
    };
    this.simplifiedFlow.errors = {
      date: '',
      phone: '',
      amount: '',
      reference: '',
      file: ''
    };
    this.simplifiedFlow.loading = false;
  };

  /**
   * Cargar automáticamente el teléfono del usuario para el flujo BDV
   */
  loadUserPhoneForBDV = async () => {
    try {
      console.log('[BDV] Cargando teléfono del usuario...');

      // Obtener el código de la persona del usuario autenticado
      const personCode = this._auth.sessionUser?.person_code;

      if (!personCode) {
        console.warn('[BDV] No se encontró person_code en sessionUser');
        return;
      }

      console.log('[BDV] Person code:', personCode);

      // Llamar al endpoint /api/person/code para obtener los contactos
      const personData = await this._user.getPersonbyCode({ code: personCode });

      if (personData && personData.constacts && personData.constacts.length > 0) {
        // Buscar el contacto de tipo PHONE_CELL (que debería estar primero por el ordenamiento)
        const phoneContact = personData.constacts.find((contact: any) =>
          contact.type_contact?.code === 'PHONE_CELL'
        );

        if (phoneContact && phoneContact.contact) {
          // Procesar el número de teléfono
          let phoneNumber = phoneContact.contact;

          console.log('[BDV] Teléfono original:', phoneNumber);

          // Convertir +58 a 0 (ejemplo: +584241318534 -> 04241318534)
          if (phoneNumber.startsWith('+58')) {
            phoneNumber = '0' + phoneNumber.substring(3);
            console.log('[BDV] Teléfono después de convertir +58 a 0:', phoneNumber);
          }

          // Asignar el teléfono completo al flujo simplificado
          this.simplifiedFlow.data.phone = phoneNumber;

          console.log('[BDV] ✅ Teléfono cargado automáticamente:', phoneNumber);
          alertifyjs.success('Teléfono cargado automáticamente: ' + phoneNumber);
        } else {
          console.warn('[BDV] No se encontró contacto de tipo PHONE_CELL');
        }
      } else {
        console.warn('[BDV] No se encontraron contactos para la persona');
      }
    } catch (error) {
      console.error('[BDV] Error al cargar teléfono automáticamente:', error);
      // No mostrar error al usuario, solo log interno
    }
  };

  /**
   * Avanzar al siguiente paso del flujo
   */
  nextStepBDV = async () => {
    this.simplifiedFlow.errors = { date: '', phone: '', amount: '', reference: '', file: '' };

    switch (this.simplifiedFlow.step) {
      case 'phone':
        if (!this.simplifiedFlow.data.phone || this.simplifiedFlow.data.phone.trim() === '') {
          this.simplifiedFlow.errors.phone = 'El teléfono es obligatorio';
          return;
        }
        this.simplifiedFlow.step = 'amount';
        break;

      case 'amount':
        if (!this.simplifiedFlow.data.amount || parseFloat(this.simplifiedFlow.data.amount) <= 0) {
          this.simplifiedFlow.errors.amount = 'El monto debe ser mayor a 0';
          return;
        }
        await this.verifyPaymentBDV();
        break;

      case 'reference':
        if (!this.simplifiedFlow.data.reference || this.simplifiedFlow.data.reference.trim() === '') {
          this.simplifiedFlow.errors.reference = 'La referencia es obligatoria';
          return;
        }
        await this.confirmPaymentBDV();
        break;

      case 'upload':
        // Comprobante opcional para workflow BDV cuando hay paymentToken (pago ubicado)
        if (this.simplifiedFlow.data.paymentToken) {
          console.log('✅ [BDV] Pago ubicado con paymentToken - Comprobante opcional');
          await this.registerPaymentBDV();
        } else {
          // Si no hay paymentToken, requerir comprobante
          if (!this.simplifiedFlow.data.file) {
            this.simplifiedFlow.errors.file = 'El comprobante es obligatorio';
            return;
          }
          await this.registerPaymentBDV();
        }
        break;
    }
  };

  /**
   * Retroceder al paso anterior
   */
  previousStepBDV = () => {
    switch (this.simplifiedFlow.step) {
      case 'amount':
        this.simplifiedFlow.step = 'phone';
        break;
      case 'reference':
        this.simplifiedFlow.step = 'amount';
        break;
      case 'upload':
        if (this.simplifiedFlow.verification.matches === 'multiple') {
          this.simplifiedFlow.step = 'reference';
        } else {
          this.simplifiedFlow.step = 'amount';
        }
        break;
      case 'confirm':
        this.simplifiedFlow.step = 'upload';
        break;
    }
  };

  /**
   * Verificar pago con servicio BDV
   */
  verifyPaymentBDV = async () => {
    this.simplifiedFlow.loading = true;

    try {
      // Para el flujo simplificado, usamos fecha actual
      const dateStr = this.formatDateForBDV(new Date());

      const response = await this._user.verifyPaymentBDV(
        this.simplifiedFlow.data.phone!,
        this.simplifiedFlow.data.amount!,
        dateStr
      );

      console.log('[BDV] Verificación response:', response);

      if (response.success && response.data) {
        const matches = response.data.matches;

        switch (matches) {
          case 'none':
            this.simplifiedFlow.verification.matches = 'none';
            this.simplifiedFlow.step = 'none-found';
            alertifyjs.warning('No se encontraron pagos con los datos proporcionados. Puedes usar el formulario tradicional.');
            break;

          case 'unique':
            this.simplifiedFlow.verification.matches = 'unique';
            this.simplifiedFlow.verification.paymentData = response.data.paymentData;
            this.simplifiedFlow.data.paymentToken = response.data.paymentToken;
            this.simplifiedFlow.step = 'upload';
            alertifyjs.success('¡Pago encontrado! Sube tu comprobante para continuar.');
            break;

          case 'multiple':
            this.simplifiedFlow.verification.matches = 'multiple';
            this.simplifiedFlow.verification.requiresReference = true;
            this.simplifiedFlow.step = 'reference';
            alertifyjs.message('Se encontraron múltiples pagos. Ingresa los últimos dígitos de la referencia.');
            break;
        }
      } else {
        throw new Error(response.message || 'Error en la verificación');
      }

    } catch (error: any) {
      console.error('[BDV] Error en verificación:', error);
      alertifyjs.error('Error al verificar el pago: ' + (error.message || 'Error desconocido'));
      this.simplifiedFlow.step = 'amount'; // Volver al paso anterior
    }

    this.simplifiedFlow.loading = false;
  };

  /**
   * Confirmar pago específico con referencia
   */
  confirmPaymentBDV = async () => {
    this.simplifiedFlow.loading = true;

    try {
      const dateStr = this.formatDateForBDV(this.simplifiedFlow.data.date!);

      const response = await this._user.confirmPaymentBDV(
        this.simplifiedFlow.data.phone!,
        this.simplifiedFlow.data.amount!,
        this.simplifiedFlow.data.reference!,
        dateStr
      );

      console.log('[BDV] Confirmación response:', response);

      if (response.success && response.data && response.data.found) {
        this.simplifiedFlow.verification.paymentData = response.data.paymentData;
        this.simplifiedFlow.data.paymentToken = response.data.paymentToken;
        this.simplifiedFlow.step = 'upload';
        alertifyjs.success('¡Pago confirmado! Sube tu comprobante para finalizar.');
      } else {
        alertifyjs.error('No se encontró el pago con la referencia proporcionada.');
        this.simplifiedFlow.step = 'reference'; // Quedarse en el mismo paso
      }

    } catch (error: any) {
      console.error('[BDV] Error en confirmación:', error);
      alertifyjs.error('Error al confirmar el pago: ' + (error.message || 'Error desconocido'));
    }

    this.simplifiedFlow.loading = false;
  };

  /**
   * Registrar pago final con paymentToken
   */
  registerPaymentBDV = async () => {
    this.simplifiedFlow.loading = true;

    try {
      // Construir los datos del pago similar al flujo tradicional
      const paymentData = {
        currency: 'USD', // Ajustar según sea necesario
        description: `Pago Móvil BDV - ${this.simplifiedFlow.data.phone}`,
        payment_method: 'PAYMENT_METHOD_ID', // Ajustar según sea necesario
        reference: this.simplifiedFlow.data.reference || 'AUTO-BDV',
        total_amount: parseFloat(this.simplifiedFlow.data.amount!),
        code_person: 'PERSON_CODE', // Obtener del contexto
        code_account_payment: this.selectedAccountPayment.code,
        date_register: this.simplifiedFlow.data.date!.toISOString(),
        type: 'AUTO'
      };

      const response = await this._user.registerPaymentWithToken(
        paymentData,
        this.simplifiedFlow.data.paymentToken!
      );

      console.log('[BDV] Registro response:', response);

      if (response.success || response.resp) {
        this.simplifiedFlow.step = 'success';
        alertifyjs.success('¡Pago registrado exitosamente!');

        // Refresh de la lista de pagos
        this.getPayments();

        // Reset del flujo después de un momento
        setTimeout(() => {
          this.resetSimplifiedFlow();
          this.simplifiedFlow.step = 'phone';
        }, 3000);
      } else {
        throw new Error(response.message || 'Error al registrar el pago');
      }

    } catch (error: any) {
      console.error('[BDV] Error en registro:', error);
      alertifyjs.error('Error al registrar el pago: ' + (error.message || 'Error desconocido'));
    }

    this.simplifiedFlow.loading = false;
  };

  /**
   * Formatear fecha para el servicio BDV
   */
  formatDateForBDV = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  /**
   * Manejar selección de archivo
   */
  onFileSelectedBDV = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      this.simplifiedFlow.data.file = file;
      this.simplifiedFlow.errors.file = '';
      console.log('[BDV] Archivo seleccionado:', file.name);
    }
  };

  /**
   * Volver al formulario tradicional
   */
  switchToTraditionalForm = () => {
    this.simplifiedFlow.enabled = false;
    this.resetSimplifiedFlow();
    alertifyjs.message('Cambiando al formulario tradicional...');
  };

  /**
   * Método temporal para testing: configurar account_payment con workflow BDV
   */
  configureBDVWorkflowForTesting = async () => {
    if (!this.selectedAccountPayment) {
      alertifyjs.error('Primero selecciona un método de pago');
      return;
    }

    try {
      const response = await this._user.setAccountPaymentBDVWorkflow(this.selectedAccountPayment.code);

      if (response.success) {
        alertifyjs.success('Account payment configurado con workflow BDV');
        console.log('[BDV] Configurado exitosamente:', response.data);

        // Actualizar el selectedAccountPayment localmente
        this.selectedAccountPayment.workflow = 'workflow_verificacion_bdv';

        // Verificar el workflow nuevamente
        await this.checkBDVWorkflow();
      } else {
        alertifyjs.error('Error al configurar workflow: ' + response.message);
      }
    } catch (error: any) {
      console.error('[BDV] Error al configurar workflow:', error);
      alertifyjs.error('Error al configurar workflow: ' + (error.message || 'Error desconocido'));
    }
  };

  // 💎 BÚSQUEDA DE PRODUCTOS - Propiedades y Métodos adicionales
  productSearchTerm: string = 'CREDIT'; // Inicializar con CREDIT por defecto
  filteredProductArray: any[] = [];

  // Filtrar productos por búsqueda
  filterProductsSearch() {
    if (!this.productArray) {
      this.filteredProductArray = [];
      return;
    }

    if (!this.productSearchTerm || this.productSearchTerm.trim() === '') {
      this.filteredProductArray = [...this.productArray];
      return;
    }

    const term = this.productSearchTerm.toLowerCase().trim();
    this.filteredProductArray = this.productArray.filter((product: any) => {
      return (
        product?.params?.name?.toLowerCase().includes(term) ||
        product?.params?.code?.toLowerCase().includes(term) ||
        (product?.params?.dinamic_code &&
          product.params.dinamic_code.some((code: string) => code.toLowerCase().includes(term)))
      );
    });

    console.log('🔍 Productos filtrados:', this.filteredProductArray.length);
  }

  // Limpiar búsqueda de productos (solo limpia el texto, no la selección)
  async clearProductSearch() {
    // Solo limpiar el término de búsqueda visual
    this.productSearchTerm = '';
    this.filteredProductArray = [...this.productArray];
  }

  // Actualizar el término de búsqueda con los productos seleccionados
  updateSearchTermFromSelection() {
    if (this.selectedProducts.length === 0) {
      this.productSearchTerm = '';
    } else if (this.selectedProducts.length === 1) {
      // Un solo producto: mostrar su código
      this.productSearchTerm = this.selectedProducts[0];
    } else if (this.selectedProducts.length === 2) {
      // Dos productos: mostrar ambos códigos separados por "y"
      this.productSearchTerm = `${this.selectedProducts[0]} y ${this.selectedProducts[1]}`;
    } else {
      // Más de 2 productos: mostrar resumen
      this.productSearchTerm = `${this.selectedProducts.length} productos seleccionados`;
    }

    console.log('🔍 Término de búsqueda actualizado:', this.productSearchTerm);
  }

}
